"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedItemsHelper = exports.LinkedItemsHelper = void 0;
class LinkedItemsHelper {
    convertLinkedItemsToArray(linkedItems) {
        const linkedItemsArray = [];
        for (const linkedItemKey of Object.keys(linkedItems)) {
            linkedItemsArray.push(linkedItems[linkedItemKey]);
        }
        return linkedItemsArray;
    }
}
exports.LinkedItemsHelper = LinkedItemsHelper;
exports.linkedItemsHelper = new LinkedItemsHelper();
//# sourceMappingURL=linked-items.helper.js.map